import type { Experiment } from '@/types/aggregation/home';
import { type SetState } from '../store';

const SEARCH_REDESIGN_EXPERIMENT_KEY = 'search-redesign';
const SEARCH_ML_EXPERIMENT_KEY = 'search-ml';

const getIsSearchRedesignVariant = (experiments: Experiment): boolean =>
    experiments[SEARCH_REDESIGN_EXPERIMENT_KEY]?.value?.toLowerCase() === 'variant';

const getSearchMlExperimentValue = (experiments: Experiment): string | null =>
    experiments[SEARCH_ML_EXPERIMENT_KEY]?.value ?? null;

export type SearchSliceProps = {
    search: {
        isSearchOpen: boolean;
        isSearchRedesignVariant: boolean;
        searchMlExperimentValue: string | null;
        toggleIsSearchOpen: () => void;
        closeSearch: () => void;
        setIsSearchRedesignVariant: (experiments: Experiment) => void;
        setSearchMlExperimentValue: (experiments: Experiment) => void;
    };
};

const ACTIONS = {
    TOGGLE_SEARCH_OPENED: 'TOGGLE_SEARCH_OPENED',
    CLOSE_SEARCH: 'CLOSE_SEARCH',
    SET_IS_SEARCH_REDESIGN_VARIANT: 'SET_IS_SEARCH_REDESIGN_VARIANT',
    SET_SEARCH_ML_EXPERIMENT_VALUE: 'SET_SEARCH_ML_EXPERIMENT_VALUE'
};

export const searchSlice = ({ set }: SetState<SearchSliceProps>): SearchSliceProps => ({
    search: {
        isSearchOpen: false,
        isSearchRedesignVariant: false,
        searchMlExperimentValue: null,
        toggleIsSearchOpen: () =>
            set(
                (state) => ({
                    search: {
                        ...state.search,
                        isSearchOpen: !state.search.isSearchOpen
                    }
                }),
                undefined,
                ACTIONS.TOGGLE_SEARCH_OPENED
            ),
        closeSearch: () =>
            set(
                (state) =>
                    state.search.isSearchOpen
                        ? {
                              search: {
                                  ...state.search,
                                  isSearchOpen: false
                              }
                          }
                        : state,
                undefined,
                ACTIONS.CLOSE_SEARCH
            ),
        setIsSearchRedesignVariant: (experiments: Experiment) =>
            set(
                (state) => ({
                    search: {
                        ...state.search,
                        isSearchRedesignVariant: getIsSearchRedesignVariant(experiments)
                    }
                }),
                undefined,
                ACTIONS.SET_IS_SEARCH_REDESIGN_VARIANT
            ),
        setSearchMlExperimentValue: (experiments: Experiment) =>
            set(
                (state) => ({
                    search: {
                        ...state.search,
                        searchMlExperimentValue: getSearchMlExperimentValue(experiments)
                    }
                }),
                undefined,
                ACTIONS.SET_SEARCH_ML_EXPERIMENT_VALUE
            )
    }
});
